export default {
  name: 'SliderMarker',

  props: {
    mark: {
      type: [String, Object]
    }
  },
  render() {
    let label = typeof this.mark === 'string' ? this.mark : this.mark.label;

    return (
      <div class="yj-slider__marks-text" style={ this.mark.style || {} }>
        { label }
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/slider/src/marker.js